import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { afterdiscount, getTotal, removItem } from '../redux/Slice/foodSlice';
import { NavLink } from 'react-router-dom';

const Sells = () => {

    const [cupan, setCupan] = useState()

    const dispatch = useDispatch()
    const cartdata = useSelector(state => state.food.cart)
    const item = useSelector(state => (state.food))
    const { cart, totalPrices, cupancode } = item;
    const discount = useSelector(state => state.food.afterdiscount)


    useEffect(() => {
        dispatch(getTotal())
       dispatch(afterdiscount())
    }, [cart, cupancode])

    return (
        <div>
            <section className="h-100 gradient-custom">
                <div className="container py-1">
                    <div className="row d-flex justify-content-center my-4">
                        <div className="col-md-8">
                            <div className="card mb-4" style={{ height: '80vh', overflowY: 'scroll' }}>
                                <div className="card-header py-3">
                                    <h5 className="mb-0">Total cart item : {cartdata.length}</h5>
                                </div>

                                {
                                    cartdata.map((ele) => {
                                        return (
                                            <div className="card-body">
                                                {/* <!-- Single item --> */}
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
                                                        {/* <!-- Image --> */}
                                                        <div className="bg-image hover-overlay hover-zoom ripple rounded" data-mdb-ripple-color="light">
                                                            <img src={ele.image}
                                                                className="w-100 img-fluid" style={{ objectFit: 'cover' }} alt="Blue Jeans Jacket" />
                                                            <a href="#!">
                                                                <div className="mask" style={{ backgroundColor: "rgba(251, 251, 251, 0.2)" }}></div>
                                                            </a>
                                                        </div>
                                                        {/* <!-- Image --> */}
                                                    </div>

                                                    <div className="col-lg-5 col-md-6 mb-4 mb-lg-0">
                                                        {/* <!-- Data --> */}
                                                        <p><strong>{ele.name}</strong></p>
                                                        <p>{ele.description}</p>

                                                        <button type="button"
                                                            onClick={() => dispatch(removItem(ele.id))}
                                                            className="btn btn-primary btn-sm me-1 mb-2" data-mdb-toggle="tooltip"
                                                            title="Remove item">
                                                            <i className="fas fa-trash"></i>
                                                        </button>


                                                        {/* <!-- Data --> */}
                                                    </div>

                                                    <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                                                        {/* <!-- Quantity --> */}
                                                        <div className="d-flex mb-4" style={{ maxWidth: "300px" }}>



                                                            <div className="form-outline">
                                                                <input id="form1" min="0" value={ele.quantity}
                                                                    style={{ textAlign: 'center' }}
                                                                    name="quantity" type="number" className="form-control" />

                                                            </div>

                                                            {/* <button className="btn btn-primary px-3 ms-2"
                                                                onClick={()=>dispatch(Inc())}>
                                                                <i className="fas fa-plus"></i>
                                                            </button> */}

                                                        </div>
                                                        {/* <!-- Quantity --> */}

                                                        {/* <!-- Price --> */}
                                                        <p className="text-start text-md-center">
                                                            <strong> price : ₹{ele.price}</strong>
                                                        </p>
                                                        {/* <!-- Price --> */}
                                                    </div>
                                                </div>
                                                {/* <!-- Single item --> */}

                                                <hr className="my-4" />


                                            </div>
                                        )
                                    })
                                }

                            </div>

                        </div>
                        <div className="col-md-4">
                            <div className="card mb-4">
                                <div className="card-header py-3">
                                    <h5 className="mb-0">Summary</h5>
                                </div>
                                <div className="card-body">
                                    <ul className="list-group list-group-flush">
                                        <li style={{ listStyle: 'none' }}>
                                            <div className=" col- mb-3">
                                                <label for="exampleInputEmail1" className="form-label">apply cupan code to get 10% off on your first swiggy order</label>

                                                <input 
                                                    onChange={(e) =>
                                                        setCupan(e.target.value)
                                                    }
                                                    required type="text"
                                                    className="form-control " id="exampleInputEmail1" aria-describedby="emailHelp"
                                                    name='name'

                                                />

                                               {
                                                    cupan === cupancode ? <li style={{ color: 'green' }}
                                                        className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                                                        cupan applied
                                                    </li> : <li style={{ color: '' }}
                                                        className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                                                        cupan not applied
                                                    </li>
                                               }


                                            </div>
                                        </li>
                                       
                                        <li
                                            className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                                            Total quantity :
                                             <span>{cartdata.length}</span>
                                        </li>

                                        {
                                            cupan === cupancode ? <li style={{ color: 'green' }} className="list-group-item d-flex justify-content-between align-items-center px-0"
                                                onChange={() => alert("Cupan code apply successfully")}
                                            >
                                                total amount:
                                                <span>
                                                    ₹{discount.toFixed(2)}
                                                </span>
                                            </li> : <li style={{ color: 'red' }} className="list-group-item d-flex justify-content-between  align-items-center px-0">
                                                total amount:
                                                <span>
                                                    ₹{totalPrices.toFixed(2)}
                                                </span>
                                            </li>


                                        }

                                        {
                                            cupan === cupancode ? <li className="list-group-item d-flex justify-content-between  align-items-center px-0">
                                                <strong>
                                                    total amount:

                                                </strong>
                                                <span>
                                                    ₹{discount.toFixed(2)}
                                                </span>
                                            </li> : <li className="list-group-item d-flex justify-content-between  align-items-center px-0">
                                                <strong>
                                                    total amount:

                                                </strong>
                                                <span>
                                                    ₹{totalPrices.toFixed(2)}
                                                </span>
                                            </li>
                                        }
                                    </ul>

                                    <NavLink to='/sells/order'>
                                        <button type="button" onClick={() => dispatch(afterdiscount())} className="btn btn-primary btn-lg btn-block">
                                            order now
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Sells;